import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useManagedMutation } from 'utils/managedHooks';
import { CREATE_VONAGE_SESSION } from 'store/mutations';
import { Spinner } from 'admin-components/components';
import { Row, Column } from 'components/shared/Layout';
import VonageFrame from './VonageFrame';

const VonageFrameWrapper = ({
  agentEmail,
  bookingReference,
  amount,
  currency,
  city,
  country,
  houseNumberOrName,
  postalCode,
  street,
  stateOrProvince,
  hasHotel,
  location,
  shopperEmail,
  isThalys
}) => {
  const [sessionData, setSessionData] = useState(null);
  const [createVonageSession, { loading }] = useManagedMutation(CREATE_VONAGE_SESSION);

  useEffect(
    () => {
      async function setupVonageSession() {
        const result = await createVonageSession({
          variables: {
            agentEmail,
            isThalys,
            bookingReference,
            paymentData: {
              amount,
              currency,
              billingAddress: {
                city,
                country,
                houseNumberOrName,
                postalCode,
                street,
                stateOrProvince
              },
              hasHotel,
              location,
              shopperEmail
            }
          }
        });
        if (result.data?.createVonageSession) {
          setSessionData(result.data?.createVonageSession);
        }
      }
      setupVonageSession();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return sessionData && !loading ? (
    <VonageFrame
      iframeURL={sessionData.iframeUrl}
      accessToken={sessionData.agentAccessToken}
      refreshToken={sessionData.agentRefreshToken}
    />
  ) : (
    <Row height="100%">
      <Column alignItems="center" justifyContent="center">
        <Spinner />
      </Column>
    </Row>
  );
};

VonageFrameWrapper.propTypes = {
  agentEmail: PropTypes.string.isRequired,
  bookingReference: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  city: PropTypes.string,
  country: PropTypes.string,
  houseNumberOrName: PropTypes.string,
  postalCode: PropTypes.string,
  street: PropTypes.string,
  stateOrProvince: PropTypes.string,
  hasHotel: PropTypes.bool.isRequired,
  location: PropTypes.string.isRequired,
  shopperEmail: PropTypes.string,
  isThalys: PropTypes.bool
};

export default VonageFrameWrapper;
